/**
 * Central QueryClient instance for the ReffConnect dashboard.
 *
 * Tuned defaults:
 *  - staleTime 60 s  → data is "fresh" for 1 min; navigating between pages
 *                       serves instantly from cache without a spinner.
 *  - gcTime 15 min   → unused cache entries are garbage-collected after 15 min.
 *  - refetchOnWindowFocus OFF globally — we enable it selectively per-query
 *    with a debounce guard so that "focus flooding" never happens.
 *  - retry 1 with exponential back-off (max 8 s).
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 1000 * 60 * 15,
      refetchOnWindowFocus: false,
      refetchOnReconnect: 'always',
      retry: 1,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
    },
    mutations: {
      retry: 0,
    },
  },
});
